<div class="max-w-[1000px] h-[70vh]">
  <div class="flex w-full h-full">
    <div
      class="mr-5 p-2 w-1/4 h-full ring-1 ring-inset ring-slate-200 rounded-md"
    >
      @if (options != null) {
        <confect-category-menu
          [collapsable]="true"
          [structure]="options"
          [currentOption]="currentOption()"
          (select)="setCurrentOption($event)"
        ></confect-category-menu>
      } @else {
        <div class="text-center px-2 text-gray-400 text-lg">
          No accesible company with designs found.
        </div>
      }
    </div>
    <div class="col-span-3 w-3/4 h-full">
      <div class="h-10 mb-5 flex items-center">
        <confect-input
          class="w-full"
          inputIcon="search"
          placeholder="Search for the design you want to import."
          [(ngModel)]="searchString"
        ></confect-input>
      </div>
      <div [style.height]="'calc(100% - 3.75rem)'">
        <ngx-confect-table
          [rows]="currentDesigns()"
          [header]="tableHeader"
          [scroll]="true"
          class="h-full"
          emptyState="No designs found."
        >
          <ng-template tableContent let-row="row" let-cols="cols">
            @for (col of cols; track col.key; let i = $index) {
              <td
                class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700 text-ellipsis truncate"
              >
                @if (col.key === "img") {
                  <div
                    class="h-12 w-12 rounded-md overflow-hidden"
                    tooltip
                    tooltipPosition="left"
                    [tooltipNoBox]="true"
                    [tooltipTemplate]="imageTooltip"
                  >
                    <img
                      [src]="row.thumbnail"
                      class="w-full h-full object-contain"
                    />
                  </div>
                  <ng-template #imageTooltip>
                    <div
                      class="h-40 w-40 border-slate-200 border-2 shadow-md rounded-md overflow-hidden"
                    >
                      <img
                        [src]="row.thumbnail"
                        class="w-full h-full object-contain"
                      />
                    </div>
                  </ng-template>
                } @else if (col.key === "import") {
                  <div class="flex justify-end items-center w-full">
                    <confect-button type="secondary" (click)="rowClicked(row)"
                      >Import</confect-button
                    >
                  </div>
                } @else {
                  <span
                    tooltip
                    tooltipPosition="above"
                    [tooltipText]="row[col.key]"
                    >{{ row[col.key] }}
                  </span>
                }
              </td>
            }
          </ng-template>
        </ngx-confect-table>
      </div>

      <!-- <ngx-designs-overview-import-table
          class="h-full"
          [creatives]="designs[currentOption.option]"
          (creativeSelected)="rowClicked($event)"
        /> -->
    </div>
  </div>
</div>
